import styled from 'styled-components';

export const BaseContainer = styled.div`
  width: 45%;
  margin: 10px 0;
`;
